





































import { GeekItem, Empty } from '@/models';
import { ActionIds, Guide, GuideStep, IntroductionGuideStep } from '@/models/guides';
import { Actions, typedStore } from '@/store';
import { AvatarSet, FirstAndLastNameSet, IntroductionGuideModal, NickSet } from '@/components/guides';
import { ToastsService } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'IntroductionGuide',
  props: {
    guide: Object as () => Guide,
  },
  components: {
    AvatarSet: () => Promise.resolve(AvatarSet),
    FirstAndLastNameSet: () => Promise.resolve(FirstAndLastNameSet),
    IntroductionGuideModal: () => Promise.resolve(IntroductionGuideModal),
    NickSet: () => Promise.resolve(NickSet),
  },
  async created(): Promise<void> {
    Promise.all([
      await this.$store.dispatch(Actions.guides.fetchGuideUserBasicInfo),
      await this.$store.dispatch(Actions.guides.fetchGuideMasterBasicInfo, this.guide?.guideMasterId),
      await this.$store.dispatch(Actions.guides.fetchGuideSteps, this.guide.id),
    ]);
  },
  computed: {
    guideSteps(): GuideStep[] {
      return typedStore(this).state.guides.guideSteps;
    },
    guideMaster(): GeekItem {
      return typedStore(this).state.guides.guideMaster;
    },
    guideUser(): GeekItem {
      return typedStore(this).state.guides.guideUser;
    },
    firstAndLastNameSetGuide(): GuideStep | undefined {
      return this.guideSteps.find(n => n.step === IntroductionGuideStep.FirstAndLastNameSet);
    },
    nickSetGuide(): GuideStep | undefined {
      return this.guideSteps.find(n => n.step === IntroductionGuideStep.NickSet);
    },
    avatarSetGuide(): GuideStep | undefined {
      return this.guideSteps.find(n => n.step === IntroductionGuideStep.AvatarSet);
    },
    step(): { name: string, data: GuideStep } {
      if (this.firstAndLastNameSetGuide) {
        return { name: 'FirstAndLastNameSet', data: this.firstAndLastNameSetGuide};
      }
      if (this.nickSetGuide) {
        return { name: 'NickSet', data: this.nickSetGuide};
      }
      if (this.avatarSetGuide) {
        return { name: 'AvatarSet', data: this.avatarSetGuide };
      }
      return null as unknown as { name: string, data: any };
    },
    inAnyStepPending(): boolean {
      return !!this.step;
    },
    isValid(): boolean {
      return !(this as any).errors.items.length;
    },
    skipButtonText(): string {
      return this.step.name === 'FirstAndLastNameSet'
        ? this.$t('guides.introduction-guide.skip') as string
        : this.$t('guides.introduction-guide.skip-and-add-later') as string;
    },
    nextButtonText(): string {
      return this.guideSteps.length > 1
        ? this.$t('guides.introduction-guide.next') as string
        : this.$t('guides.introduction-guide.finish') as string;
    },
    isOtherGeekDisplayed(): boolean {
      return typedStore(this).state.geek.geek.id !== typedStore(this).state.geek.current.id;
    },
  },
  methods: {
    async markStepAsFinished() {
      const actionIds: ActionIds = { guideId: this.guide.id, stepId: this.step.data.id };
      await this.$store.dispatch(Actions.guides.markStepAsFinished, actionIds);
      await this.$store.dispatch(Actions.guides.fetchGuideSteps, this.guide.id);

      if (!this.step && !this.isOtherGeekDisplayed) {
        await this.$store.dispatch(Actions.geek.fetchGeekBasicInfo);
      }
      if (!this.step) {
        await this.$store.dispatch(Actions.guides.fetchAllGuides);
        await this.$store.dispatch(Actions.geek.fetchCurrent);
      }
    },
    async applyStepChanges() {
      // this method should invoke methods in step components to set name, nick or avatar.
      if (this.step.name === 'AvatarSet' && !(this.$refs.step as any).avatarUploaded) {
        ToastsService.warning(this.$t('guides.introduction-guide.avatar-set.empty').toString());
        return;
      }
      await (this.$refs.step as any).applyChanges();
      await this.markStepAsFinished();
    },
  },
});
